import { IAuthenticatorService } from '../authenticator-service';
import { AuthenticateMode, IAuthenticatePartialComponent, ILoginResponseResolveData } from '../models';
import { AuthenticatePartialComponent } from './authenticate-partial-component';

export class AuthenticateLoginPartialComponent extends AuthenticatePartialComponent {
  private readonly emailRegex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/gi;

  private readonly emailElement: HTMLInputElement;
  private readonly passwordElement: HTMLInputElement;
  private readonly submitElement: HTMLButtonElement;
  private readonly rememberMeElement: HTMLInputElement;
  private readonly validationMessageComponent: IAuthenticatePartialComponent;

  constructor(rootElement: string | HTMLElement, authenticator?: IAuthenticatorService) {
    super(rootElement, authenticator);

    this.emailElement = this.querySelector('.partnernet-login-panel__input__email') as HTMLInputElement;
    this.passwordElement = this.querySelector('.partnernet-login-panel__input__password') as HTMLInputElement;
    this.submitElement = this.querySelector('.partnernet-login-panel__input__submit') as HTMLButtonElement;
    this.rememberMeElement = this.querySelector('.partnernet-login-panel__input__checkbox') as HTMLInputElement;
    this.validationMessageComponent = new AuthenticatePartialComponent(
      this.querySelector('.partnernet-login-panel__validation-message'),
    );

    this.assignEvents();
  }

  private assignEvents(): void {
    this.emailElement.addEventListener(
      'keyup',
      (ev: KeyboardEvent): void => {
        ev.preventDefault();
        this.validate();
      },
    );

    this.passwordElement.addEventListener(
      'keyup',
      (ev: KeyboardEvent): void => {
        ev.preventDefault();
        this.validate();
      },
    );

    this.submitElement.addEventListener(
      'click',
      (ev: MouseEvent): void => {
        ev.preventDefault();
        if (!this.validate()) {
          return;
        }

        this.resetError();
        this.authenticator
          .login(this.emailElement.value, this.passwordElement.value, this.rememberMeElement.checked)
          .then(
            (result: ILoginResponseResolveData): void => {
              if (typeof result !== 'object' || !result.authenticated) {
                this.handleError();
              } else if (
                result.requiresSelection &&
                typeof result.profiles === 'object' &&
                result.profiles instanceof Array
              ) {
                this.onSubmit(
                  AuthenticateMode.SelectProfile,
                  this.emailElement.value,
                  this.passwordElement.value,
                  this.rememberMeElement.checked,
                  result.profiles,
                );
              } else {
                this.onSubmit();
              }
            },
            (): void => {
              this.handleError();
            },
          );
      },
    );
  }

  private resetError(): void {
    this.validationMessageComponent.hide();
    this.submitElement.classList.add('jbr-btn--loading');
  }

  private handleError(): void {
    this.submitElement.classList.remove('jbr-btn--loading');
    this.validationMessageComponent.show();
  }

  private validate(): boolean {
    this.submitElement.disabled = !(this.validateEmail() && this.validatePassword());
    return !this.submitElement.disabled;
  }

  private validateEmail(): boolean {
    this.emailRegex.lastIndex = 0;
    return this.emailElement.value !== '' && this.emailRegex.test(this.emailElement.value);
  }

  private validatePassword(): boolean {
    return this.passwordElement.value !== '';
  }
}
